const STORAGE_KEY = 'marketing-attribution';
const MAX_AGE_DAYS = 7;

export const storeMarketingAttribution = (data) => {
  if (!data) return;
  const payload = {
    ...data,
    storedAt: Date.now()
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
};

export const getMarketingAttribution = () => {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const data = JSON.parse(raw);
    const maxAge = MAX_AGE_DAYS * 24 * 60 * 60 * 1000;
    if (data.storedAt && Date.now() - data.storedAt > maxAge) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data;
  } catch (error) {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
};

export const clearMarketingAttribution = () => {
  localStorage.removeItem(STORAGE_KEY);
};
